var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"albums"},[_c('h1',{staticClass:"page-title"},[_vm._v("Albums")]),_c('v-divider',{staticClass:"divider"}),_c('div',{staticClass:"album-grid"},_vm._l((_vm.$store.state.library.albums),function(album){return _c('item-square',{key:album.id,attrs:{"show-year":"","item":album}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }